import React from 'react';
import { rightStyle } from '../../styles';

function wrapperStyle({ width, active, duration }) {
  return Object.assign({}, rightStyle(), {
    width,
    right: active ? 0 : -width,
    transition: `right ${duration}ms cubic-bezier(0.0, 0.0, 0.2, 1)`
  });
}

export default ({ children, width, active, duration }) => (
  <div
    style={wrapperStyle({
      width,
      active,
      duration
    })}
  >
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/transitions/PanelVertical/index.js